import React from 'react';
import * as Fi from 'react-icons/fi';
import { LuSparkles } from 'react-icons/lu';
import DocumentChatPanel from '../Chatbot/DocumentChatPanel';
import type { Document } from '../../types';

type IconProps = React.SVGAttributes<SVGElement>;
const FiChevronRight = Fi.FiChevronRight as React.FC<IconProps>;
const SparkIcon = LuSparkles as React.FC<IconProps>;

export interface DocumentViewerSidebarProps {
  document: Document;
  /** Extracted document text for the chat (e.g. from PDF). */
  documentContent?: string | null;
  documentContentLoading?: boolean;
  isOpen: boolean;
  onToggle: () => void;
}

const DocumentViewerSidebar: React.FC<DocumentViewerSidebarProps> = ({
  document: doc,
  documentContent = null,
  documentContentLoading = false,
  isOpen,
  onToggle,
}) => {
  if (!isOpen) {
    return (
      <aside className="w-10 shrink-0 flex flex-col items-center bg-white dark:bg-slate-800">
        <button
          type="button"
          onClick={onToggle}
          className="mt-4 p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
          title="Show ClickCompanion"
          aria-label="Show ClickCompanion"
        >
          <SparkIcon className="w-5 h-5" />
        </button>
      </aside>
    );
  }

  return (
    <aside className="w-72 shrink-0 flex flex-col bg-white dark:bg-slate-800 shadow-sm overflow-hidden">
      <div className="shrink-0 flex items-center justify-between px-2 py-1.5">
        <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-700 dark:text-slate-200">
          <img src="/ICON-GREEN.png" alt="" className="h-4 w-auto" aria-hidden />
          Click Companion
        </span>
        <button
          type="button"
          onClick={onToggle}
          className="p-1.5 rounded text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-700 dark:hover:text-slate-200 transition-colors"
          title="Hide ClickCompanion"
          aria-label="Hide ClickCompanion"
        >
          <FiChevronRight className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 flex flex-col min-h-0 overflow-hidden p-4">
        <DocumentChatPanel
          document={doc}
          documentContent={documentContentLoading ? null : documentContent}
          className="flex-1 min-h-0"
        />
        {documentContentLoading && (
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">Reading document...</p>
        )}
      </div>
    </aside>
  );
};

export default DocumentViewerSidebar;
